import { Button, ModalComponentWrapper } from '@/shared/components';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  content: ReactNode;
  onClose: () => void;
}

export const ResultModal = ({ content, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <ModalComponentWrapper>
      {content}
      <div className="flex flex-col gap-[1.6rem]">
        <Button
          type="submit"
          size="lg"
          disabled={false}
          className="h-[6rem]"
          onClick={onClose}
          variant={'secondary'}>
          <span className="headline4">{t('common.doneButton')}</span>
        </Button>
      </div>
    </ModalComponentWrapper>
  );
};
